<template>
  <article class="control-page">
    <div v-if="controlsDisplayed" class="control-panel">
      <form>
        <h3>Account Modifiers</h3>
        <div>
          <input type="button" value="No Revenue" @click="clearRevenue">
          <input type="button" value="Reset account" @click="resetRevenue">
        </div>
      </form>
    </div>
    <button type="button" class="controls-toggle" @click="toggleControls">C</button>
    <revenue />
  </article>
</template>

<script>
import store from '@/store';
import { revenue } from '@/components/advisor';

export default {
  route: {
    meta: { requiresAuth: true },
  },
  components: { revenue },
  data() {
    return {
      controlsDisplayed: true,
    };
  },
  methods: {
    toggleControls() {
      this.controlsDisplayed = !this.controlsDisplayed;
    },
    clearRevenue() {
      const billing = store.getters.billing;
      billing.billings = [];
    },
    resetRevenue() {
      store.dispatch('fetchBilling');
    },
  },
  async beforeRouteEnter(to, from, next) {
    return Promise.all([
      store.dispatch('fetchBilling'),
    ])
      .then(next);
  },
};
</script>
